import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/Decor_profile.png'


const _withScopeId = n => (_pushScopeId("data-v-34c9d962"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "view works" }
const _hoisted_2 = { class: "works__body" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "works__decor",
  src: _imports_0
}, null, -1))

import { onBeforeMount, ref, Ref } from 'vue';
import { useRouter } from 'vue-router';
import { WorksSevice, Works, WorkItem } from '@/services/WorksService';
import BaseFeedCreation from '@/components/feed/BaseFeedCreation.vue';
import BaseBackLink from '@/components/shared/BaseBackLink.vue';
import BaseLoader from '@/components/shared/BaseLoader.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'MyWorksView',
  setup(__props) {

const router = useRouter();

const works: Ref<Works<WorkItem> | null> = ref(null);

onBeforeMount(async () => {
	// Get works
	WorksSevice.getSelfWorks().then((_works) => (works.value = _works));
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (works.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(BaseBackLink, {
            onClick: _unref(router).back,
            class: "back-link-container"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Мои работы ")
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createElementVNode("div", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(works.value.items, (work) => {
              return (_openBlock(), _createBlock(BaseFeedCreation, {
                key: work.id,
                id: work.id,
                format: "self-work",
                author: {
						user_id: work.owner_id,
						avatar: work.user_avatar,
						nickname: work.user_nickname
					},
                image: work.image_url,
                text: work.description,
                date: work.created_at,
                likes: work.likes_count,
                preview: work.preview
              }, null, 8, ["id", "author", "image", "text", "date", "likes", "preview"]))
            }), 128))
          ])
        ], 64))
      : (_openBlock(), _createBlock(BaseLoader, { key: 1 })),
    _hoisted_3
  ]))
}
}

})